<script setup>
import {defineProps} from 'vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

const props = defineProps(["data"])

const value = props.data || 0
</script>

<template>
  <div class="change-indicator">
    <div v-if="value > 0" class="positive-change">
      +{{ value }}
    </div>
    <div v-else-if="value === 0" class="neutral-change">
      {{ value }}
    </div>
    <div v-else-if="value < 0" class="negative-change">
      {{ Math.abs(value) }}
    </div>
    <div v-else class="no-data">
      —
    </div>
  </div>
</template>

<style scoped>
.change-indicator {
  display: flex;
  align-items: center;
}

.positive-change {
  color: rgb(105, 248, 147);
  font-weight: 500;
  display: flex;
  align-items: center;
}

.negative-change {
  color: rgb(248, 105, 105);
  font-weight: 500;
  display: flex;
  align-items: center;
}

.neutral-change {
  color: rgba(255, 255, 255, 0.47);
  font-weight: 500;
  display: flex;
  align-items: center;
}

.fa-icon {
  font-size: 0.8rem;
}

.no-data {
  color: #6B7280;
  font-weight: 500;
}
</style>
